import { apiClient } from './client';

export type ReadinessStepKey =
    | 'account_created'
    | 'profile_completed'
    | 'first_patient_added'
    | 'first_report_created'
    | 'first_report_completed';

type ReadinessChecklistStep = {
    key: ReadinessStepKey;
    completed: boolean;
};

type ReadinessChecklist = {
    hidden: boolean;
    completed: boolean;
    completed_at: string | null;
    progress: {
        completed: number;
        total: number;
        percent: number;
    };
    steps: ReadinessChecklistStep[];
};

type ReadinessChecklistResponse = {
    data: ReadinessChecklist;
};

export const readinessApi = {
    get: async (): Promise<ReadinessChecklist> => {
        const response = await apiClient.get<ReadinessChecklistResponse>('/me/readiness');

        return (response as unknown as ReadinessChecklistResponse).data;
    },
    complete: async (): Promise<ReadinessChecklist> => {
        const response =
            await apiClient.patch<ReadinessChecklistResponse>('/me/readiness/completed');

        return (response as unknown as ReadinessChecklistResponse).data;
    },
};
